import RestResource from '../rest.service';

export default class ProjectionsService extends RestResource {
  static _STATE_CONFIRMED = 'confirmed';
  static _STATE_INITIAL = 'initial';
  static _STATE_WARNING = 'warning';
  static _STATE_DANGER = 'danger';

  map(payload) {
    return {
      producer_id: payload.producer,
      variety_id: payload.variety,
      quantity: payload.quantity,
      competitor_quantity: payload.competitorQuantity,
      competitor_variety: payload.competitorVariety,
      period: payload.period,
      campaign_id: payload.campaign,
      comment: payload.comment,
    };
  }

  constructor() {
    super('projections');
  }
}
